import { Link } from "@tanstack/react-router";
import { SITE, SERVICE_AREAS, SECONDARY_SERVICES } from "@/lib/site";
import { Phone, Mail, MapPin } from "lucide-react";

export function SiteFooter() {
  return (
    <footer className="border-t border-border bg-primary text-primary-foreground">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 lg:grid-cols-4 lg:px-8">
        <div>
          <div className="font-serif text-xl">{SITE.name}</div>
          <p className="mt-3 text-sm text-primary-foreground/70">
            Complete property care across the Sarasota coast — home watch, cleanouts, hauling, removals and concierge, all from one trusted local team.
          </p>
          <div className="mt-4 inline-flex items-center gap-2 rounded-full border border-primary-foreground/20 px-3 py-1 text-xs uppercase tracking-wider text-primary-foreground/80">
            Licensed &amp; Insured
          </div>
        </div>
        <div>
          <h4 className="text-xs font-semibold uppercase tracking-wider text-[oklch(0.78_0.12_82)]">Services</h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/home-watch-services" className="hover:underline">Home Watch Services</Link></li>
            {SECONDARY_SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/${s.slug}` as string} className="hover:underline">{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-semibold uppercase tracking-wider text-[oklch(0.78_0.12_82)]">Service Areas</h4>
          <ul className="mt-4 grid grid-cols-2 gap-y-2 text-sm">
            {SERVICE_AREAS.map((a) => (
              <li key={a}><Link to="/service-areas" className="hover:underline">{a}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-semibold uppercase tracking-wider text-[oklch(0.78_0.12_82)]">Contact</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li className="flex items-start gap-2"><Phone className="mt-0.5 h-4 w-4" /><a href={SITE.phoneHref}>{SITE.phone}</a></li>
            <li className="flex items-start gap-2"><Mail className="mt-0.5 h-4 w-4" /><a href={`mailto:${SITE.email}`}>{SITE.email}</a></li>
            <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4" /> {SITE.city}, {SITE.region}</li>
            <li className="text-primary-foreground/70">{SITE.hours}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-primary-foreground/10 pb-[calc(3.5rem+env(safe-area-inset-bottom))] lg:pb-0">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-primary-foreground/60 sm:flex-row sm:px-6 lg:px-8">
          <div>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</div>
          <div>{SITE.domain}</div>
        </div>
      </div>
    </footer>
  );
}